import type { DeviceFragment } from '@cobliteam/api-lib/src/__generated__/graphql';
import { MultiSelectVehicleAssociationType } from '@cobliteam/common-types';
import { filterGetByKeys, filterSetParamFilters, type IFiltersDef } from '@cobliteam/ui-business/components/DataTable';
import type { StateCreator } from 'zustand';
import type { DevicesSlices } from '.';

interface DevicesSliceState {
  devices: DeviceFragment[];
  devicesFilters: IFiltersDef[];
  selectedDevice: DeviceFragment | null;
  associationStatus: MultiSelectVehicleAssociationType;
  exporting: boolean;
  setDevices: (devices: DeviceFragment[]) => void;
  setDevicesFilters: (filter: IFiltersDef) => void;
  setSelectedDevice: (device: DeviceFragment | null) => void;
  clearDevicesFilters: () => void;
  setAssociationStatus: (associationStatus: MultiSelectVehicleAssociationType) => void;
  setExporting: (exporting: boolean) => void;
}

type StateCreatorDevices = StateCreator<DevicesSlices, [['zustand/devtools', never]], [], DevicesSliceState>;

const devicesFilters = () => filterGetByKeys(['MultiSelectDeviceType', 'MultiSelectDeviceStatus']);

const createDevicesSlice: StateCreatorDevices = (set) => ({
  devices: [],
  devicesFilters: devicesFilters(),
  selectedDevice: null,
  associationStatus: MultiSelectVehicleAssociationType.ASSOCIATED_TO_VEHICLE,
  exporting: false,
  setDevices: (devices) => set({ devices }),
  setDevicesFilters: (filter: IFiltersDef) =>
    set((state) => {
      const filterDef = filterGetByKeys([filter.key])[0];

      const index = state.devicesFilters.findIndex((f: IFiltersDef) => f.key === filter.key);

      const filters = index !== -1 ? [...state.devicesFilters.slice(0, index), filter, ...state.devicesFilters.slice(index + 1)] : [...state.devicesFilters, filter];

      filterSetParamFilters({ ...filterDef, value: filter.value });

      return { devicesFilters: filters };
    }),
  setSelectedDevice: (device) => set({ selectedDevice: device }),
  setAssociationStatus: (associationStatus) => set({ associationStatus }),
  setExporting: (exporting) => set({ exporting }),
  clearDevicesFilters: () =>
    set({
      devicesFilters: devicesFilters(),
    }),
});

export type { DevicesSliceState };
export default createDevicesSlice;
